import React, { useMemo, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";


export default function TableHistorialAprobaciones({ dataFilas, onClickVerDocumento, anioSeleccionado, onChangeAnio }) {

  const [anioMostrado, setanioMostrado] = useState(anioSeleccionado);


  function GetComponenteVerDocumentoPDF(referencia) {
    var referenciaNoEsValidad = referencia === null || referencia === undefined || referencia === ""
    if (!referenciaNoEsValidad) {
      return (
        <Button style={{ backgroundColor: "#FFC200", float: "none", height: "27px", width: "27px" }} className="m-0 p-1 btn-icono" onClick={() => onClickVerDocumento(referencia)}>
          <i className="fas fa-eye" aria-hidden="true" ></i>
        </Button>
      )
    }
    else {
      return (<div></div>)
    }


  }

  const filas = useMemo(
    () => [...dataFilas], [dataFilas]
  )

  const columnas = React.useMemo(
    () => [
      {
        Header: 'Tipo Solicitud',
        accessor: 'tipo',
      },
      {
        Header: 'Fecha de Solicitud',
        accessor: 'fechaSolicitud',
        Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
      },
      {
        Header: 'Identificación',
        accessor: 'identificacion', // accessor is the "key" in the data
      },
      {
        Header: 'Nombre de servidor',
        accessor: 'nombres',
      },


      {
        Header: 'Aprobado por',
        accessor: 'nombreAutoridadAprobo',
      },
      {
        Header: 'Fecha desde',
        accessor: 'fechaDesde',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

      },
      {
        Header: 'Fecha hasta',
        accessor: 'fechaHasta',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

      },
      {
        Header: 'Días Ordinarios',
        accessor: 'diasOrdinarios',
      },

      {
        Header: 'Estado',
        accessor: 'estado',
      },
      {
        Header: "Documento",
        accessor: 'documento',
        Cell: ({ value }) => GetComponenteVerDocumentoPDF(value)
      }

      ,
    ], [dataFilas]
  )

  const columnasStyles = (cell) => [
    {
      HeaderName: "Nombre de servidor",
      StyleHeader: {
        textAlign: "left"
      }
    },
    {
      HeaderName: "Nombre Autoridad que aprobó",
      StyleHeader: {
        textAlign: "left"
      }
    },
    {
      HeaderName: "Documento",
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: "Estado",
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Tipo Solicitud',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: "Días Ordinarios",
      StyleHeader: {
        textAlign: "center"
      }
    }
  ]

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    visibleColumns,
    prepareRow,
    state,
    setGlobalFilter
  } = useTable(
    {
      columns: columnas,
      data: filas
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { globalFilter, pageIndex, pageSize } = state;
  const sizerows = filas.length;


  function HandleChangeAnioOnTable(anioSeleccionado) {
    if (typeof (anioSeleccionado) === "number") {
      setanioMostrado(anioSeleccionado.toString())
    }
    onChangeAnio(anioSeleccionado)
  }

  const BotonDescargarReporte = useMemo(() => {

    const URLAnios = "Aprobacion/HistorialAprobaciones/AniosDisponibles/";

    const URLREPORTE = "Aprobacion/HistorialAprobaciones/Reporte"



    if (anioSeleccionado !== undefined) {

      const anioForButton = +anioSeleccionado

      return (
        <ButtonDownloadReportTable
          api={URLREPORTE}
          nombreBoton='Reporte Historial Solicitudes Aprobadas'
          apiYears={URLAnios}
          onChangeYear={HandleChangeAnioOnTable}
          yearElegido={anioForButton}
        />
      )
    }

  }, [anioSeleccionado])


  return (
    <React.Fragment>
      <Row>
        {/* <Col xl={12}>
          <GlobalFilterTable
            filter={globalFilter}
            setFilter={setGlobalFilter}
          />
        </Col> */}
        <Col xl={12}>
            <div className="containerBtnAprobacionesVacLic">
                <GlobalFilterTable
                    filter={globalFilter}
                    setFilter={setGlobalFilter}
                />
            </div>
        </Col>
      </Row>
      <Row className="justify-content-end mb-1">
        <Col xl={3} lg={3} md={4} sm={12}>
          {BotonDescargarReporte}
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
            <thead style={{}}>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className='clickable'
                    >
                      {column.render('Header')}
                      <span>
                        {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, indirow) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>

                    {row.cells.map(cell => {
                      return getTdTableStyles(cell, { border: 'solid 1px black' }, columnasStyles(cell))

                    })}
                  </tr>
                )
              })}
            </tbody>
          </Table>
          <ComponentePaginacionTabla
            page={page}
            sizerows={sizerows}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            previousPage={previousPage}
            setPageSize={setPageSize}

          />
        </Col>
      </Row>



    </React.Fragment>
  )
}
